// (function () {
//     'use strict';

//     angular.module("imApp").factory("bspService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getEdit: function (parms) {
//                 return $ihttp.post({
//                     method: 3156,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 3158,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
